import React, { useLayoutEffect, useRef, useState } from "react";

import InputGroupContext from "./InputGroupContext";

// Wrap a set of <InputField>s in this to make their labels share one
// width (the widest label's natural width) so the inputs line up on
// both edges, regardless of per-field label text length. Re-measures
// on every render (cheap DOM reads, only triggers a state update when
// the computed width actually changes) so it stays correct across
// language switches, scale changes, and dynamic field sets.
export default function InputGroup({ children, className = "", style }) {
  const containerRef = useRef(null);
  const [groupWidth, setGroupWidth] = useState(null);

  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const labels = container.querySelectorAll('[data-grouped-label="true"]');
    if (labels.length === 0) return;

    let max = 0;
    labels.forEach((el) => {
      const prevWidth = el.style.width;
      el.style.width = "auto";
      max = Math.max(max, el.getBoundingClientRect().width);
      el.style.width = prevWidth;
    });

    setGroupWidth((prev) => (Math.abs((prev || 0) - max) > 0.5 ? max : prev));
  });

  return (
    <div ref={containerRef} className={className} style={style}>
      <InputGroupContext.Provider value={groupWidth}>
        {children}
      </InputGroupContext.Provider>
    </div>
  );
}
